/* global app, moment, _ */
/* global getHours, insertString, formatInvitationLinks */
/* global infoData, params */

"use strict";

app.controller('GiftCardController', ['$scope', '$http', '$routeParams', '$translate', '$window', '$timeout', function ($scope, $http, $routeParams, $translate, $window, $timeout) {
    $scope.Language = infoData.Country;
    $scope.info = infoData;
    // $scope.info.StripePublishKey = 'pk_test_gfgN1HoPs1PhcySxOdvZ8EOW';
    $scope.vouchers = vouchers;
    // console.log(vouchers);
    // console.log(infoData);
    $scope.cartArray = [];
    $scope.cartFormArray = [];
    $scope.totalPrice = 0; 
    var startYear = new Date().getFullYear().toString().substr(-2);
    var currentYear = new Number(startYear);
    currentYear += 20;
    $scope.currentStep = 1;
    $scope.success = false;
    $scope.beyondTheOcean = false;
    $scope.marketingEmailsLink = false;
    $scope.logo = logo;

    $scope.Language = infoData.Country;
    
    if (gym) {
		$scope.gym = gym;
		$($scope.gym[0].BODYPart).prependTo('.body-scripts');
        $($scope.gym[0].HEADPart).appendTo(document.head);
    }

    if ($scope.Language.indexOf('ena') > -1 || $scope.Language.indexOf('enu') > -1 || $scope.Language.toLowerCase().indexOf('eng') > -1) {
        $scope.beyondTheOcean = true;
    }

    $scope.reload = function (logo = false) {
        let href;
        if(infoData.LinkWebsite && logo){
            href = infoData.LinkWebsite;
        }else{
            href = window.location.origin + '/giftcard/index?GymID=' + infoData.GymID + '&NameSpace=' + infoData.NameSpace;
        }   
        window.location.replace(href);
    }

    $scope.text = 'me@example.com';
    $scope.emailFormat = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    $scope.phoneFormat = gym[0].Culture.includes('GB') ? /^[0-9]{5,11}$/ : /^[0-9]{5,15}$/;
    
    $scope.removeByAttr = function (arr, attr, value) {
        var i = arr.length;
        while (i--) {
            if (arr[i]
                && arr[i].hasOwnProperty(attr)
                && (arguments.length > 2 && arr[i][attr] === value)) {
                arr.splice(i, 1);
            }
        }
        return arr;
    }

    $scope.years = [];
    while (startYear <= currentYear) {
        $scope.years.push(startYear++);
    }


    $scope.changeStep = function (n) {
        if ($scope.success == true) {
            location.reload();
            $scope.success = false;
        }

        if(n == 3){
            updateBackEndCart();
        }

        $scope.currentStep = n;
    }

    function updateBackEndCart(){
        let dataItems = [];
        for (let index = 0; index < $scope.cartFormArray.length; index++) {
            const element = $scope.cartFormArray[index];
            let newItem = {
                DefinitionID: element.VoucherID,
                ItemName: element.Name,
                ReceipientFirstName: element.ToFirstName,
                ReceipientLastName: element.ToLastName,
                ReceipientEmail: element.ToEmail,
                Price: element.Price,
                sendGiftCardToThisEmail: element.SendToEmail,
                VoucherUniqueID: element.VoucherInnerID,
                Quantity: element.Quantity
            }

            dataItems.push(newItem);
        }

        var number = $scope.inputPhone.selectedDialCode.innerHTML + $scope.inputPhone.telInput.value;
        number = number.replace(/ /g,'');
        let lang = $translate.proposedLanguage() || $translate.use();

        let data = {
            Email: $scope.fromEmail,
            FirstName: $scope.fromFirstName,
            LastName: $scope.fromLastName,
            Telephone: number,
            Items: dataItems,
            GymID: infoData.GymID,
            Namespace: infoData.NameSpace,
            GiftCard: true
        }
    
        $http({
            method: 'POST',
            url: '/onlinebooking/UpdateCart',
            data: data
        }).success(function (data) {
            console.log(data);
        }).error(function (error) {
            console.log(error);
        });
    }

    function getBackEndCart(){
    
        $http({
            method: 'GET',
            url: '/onlinebooking/GetCart',
            params: { GiftCard: true, GymID: infoData.GymID, NameSpace: infoData.NameSpace }
        }).success(function (data) {
            let cartItems = data.CartItems
            if(cartItems.length){
                for (let index = 0; index < cartItems.length; index++) {
                    const element = cartItems[index];
                    element.VoucherInnerID = element.DefinitionID + '100' + index
                    // $scope.getCartElement = element;
                    // console.log(element);
                    // $scope.getCards(element.DefinitionID);
                    $timeout(() => $scope.giftCard = element.DefinitionID);
                    $scope.addToCard(element.DefinitionID, element.Quantity, element)
                }
            }
        }).error(function (error) {
            console.log(error);
        });
    }

    $scope.getCards = function (id) {
        $('.vouchers .voucher[data-voucherId="' + id + '"]').addClass('active');
    }

    $scope.increase = function (item) {
        item.quantity = parseInt(item.quantity);
        item.quantity = item.quantity + 1;
    }
    $scope.decrease = function (item) {
        item.quantity = parseInt(item.quantity);
        if (item.quantity > 1) {
            item.quantity = item.quantity - 1;
        }
    }

    $scope.addToCard = function (id, quantity, savedBackElement = false) {
        
        let cartResult = $.grep($scope.cartArray, function (e) { return e.VoucherID == id; });
        let newVoucher = $.grep($scope.vouchers, function (e) { return e.VoucherID == id; });
        newVoucher[0].Quantity = quantity;
        newVoucher[0].TotalPrice = quantity * newVoucher[0].Price;

        if (cartResult.length != 0) {
            cartResult[0].Quantity = quantity;
            cartResult[0].TotalPrice = quantity * cartResult[0].Price;

            let el = { VoucherID: newVoucher[0].VoucherID, VoucherInnerID: newVoucher[0].VoucherID + '100' + quantity, ToFirstName: '', ToLastName: '', ToEmail: '', SendToEmail: false, Name: newVoucher[0].Name, Price: newVoucher[0].Price, Quantity: quantity };

            if(savedBackElement){
                if(savedBackElement.VoucherUniqueID == el.VoucherInnerID){
                    el.ToFirstName = savedBackElement.ReceipientFirstName;
                    el.ToLastName = savedBackElement.ReceipientLastName;
                    el.ToEmail = savedBackElement.ReceipientEmail;
                    el.SendToEmail = savedBackElement.SendGiftCardToThisEmail;

                    $scope.cartFormArray.push(el);
                }
            }else{

                let curretItem = $.grep($scope.cartFormArray, function (e) { return e.VoucherInnerID == el.VoucherInnerID; });
                if(curretItem.length != 0){
                    // just do nothing it is impossible
                }else{
                    $scope.cartFormArray.push(el);
                }
            }

        }else{
            $scope.cartArray.push(newVoucher[0]);

            for (var i = 1; i < quantity+1; i++) {
                let giftCardItem = { VoucherID: newVoucher[0].VoucherID, VoucherInnerID: newVoucher[0].VoucherID + '100' + i, ToFirstName: '', ToLastName: '', ToEmail: '', SendToEmail: false, Name: newVoucher[0].Name, Price: newVoucher[0].Price, Quantity: quantity };

                if(savedBackElement){
                    if(savedBackElement.VoucherUniqueID == giftCardItem.VoucherInnerID){
                        giftCardItem.ToFirstName = savedBackElement.ReceipientFirstName;
                        giftCardItem.ToLastName = savedBackElement.ReceipientLastName;
                        giftCardItem.ToEmail = savedBackElement.ReceipientEmail;
                        giftCardItem.SendToEmail = savedBackElement.SendGiftCardToThisEmail;

                        $scope.cartFormArray.push(giftCardItem);
                    }
                }else{
                    $scope.cartFormArray.push(giftCardItem);
                }
            }
        }

        $('.giftcardForm .box-actions').removeClass('disabled-button');

        $scope.makeTotal();
    }

    $scope.makeTotal = function () {
        $scope.totalPrice = 0;
        if ($scope.cartArray.length > 0) {
            for (var i = 0; i < $scope.cartArray.length; i++) {
                $scope.totalPrice += $scope.cartArray[i].TotalPrice;
            }
        }

        updateBackEndCart();
    }

    $scope.deleteCartItem = function (id) {
        $scope.removeByAttr($scope.cartArray, 'VoucherID', id);
        $scope.removeByAttr($scope.cartFormArray, 'VoucherID', id);
        // $('.vouchers .voucher[data-voucherId="' + id + '"]').find('.qunatity-box input').value('1');
        // $('.vouchers .voucher[data-voucherId="' + id + '"]').removeClass('active');
        $scope.makeTotal();

        if ($scope.cartArray.length < 1) {
            $('.giftcardForm .box-actions').addClass('disabled-button');

            if ($scope.currentStep == 2 || $scope.currentStep == 3) {
                $scope.changeStep(1);
            }
        }
    }

    $scope.deleteSingleCartItem = function (id, innerId) {
        var quantity = $.grep($scope.cartArray, function (e) { return e.VoucherID == id; });

        if ($scope.cartFormArray.length == 1) {
            $scope.changeStep(1);
            $('.giftcardForm .box-actions').addClass('disabled-button');
        }

        if (quantity[0].Quantity == 1) {
            $scope.removeByAttr($scope.cartArray, 'VoucherID', id);
            $scope.removeByAttr($scope.cartFormArray, 'VoucherID', id);
        } else {
            quantity[0].Quantity = quantity[0].Quantity - 1;
            quantity[0].TotalPrice = quantity[0].Quantity * quantity[0].Price;
            $scope.removeByAttr($scope.cartFormArray, 'VoucherInnerID', innerId);
        }


        $scope.makeTotal();
    }

    $scope.PaymentIntentID = null;
    function prepareDataToOrder(token = null){
        var number = $scope.inputPhone.selectedDialCode.innerHTML + $scope.inputPhone.telInput.value;
        number = number.replace(/ /g,'');
        let lang = $translate.proposedLanguage() || $translate.use();

        var dateObjectOrder = { 
            FromFirstName: $scope.fromFirstName, 
            FromLastName: $scope.fromLastName, 
            FromTelephone: number, 
            FromEmail: $scope.fromEmail, 
            PaymentType: $scope.paymentType, 
            GiftCards: $scope.cartFormArray, 
            Namespace: infoData.NameSpace, 
            GymID: infoData.GymID, 
            ZIP: $scope.zip, 
            PaymentProvider: $scope.paymentTypeProvider, 
            PaymentIntentID: $scope.PaymentIntentID, 
            receiveEmails: $scope.marketingEmailsLink,
            Language: lang
        }

        if ($scope.paymentType == 9) {
            dateObjectOrder.Token = token
        }else if($scope.paymentType == 10){
            dateObjectOrder.OrderID = $scope.ElavonOrderID;
            dateObjectOrder.ElavonTransactionID = $scope.ElavonTransactionID;
        }

        return dateObjectOrder;
    }

    $scope.placeOrder = function (token) {
        if ( $scope.loading != true ) {
            $scope.loading = true;
            $('body .giftcard-wrapper .payment-form .form-actions').addClass('disabled');

            if ($scope.paymentType == 7) {
                $scope.paymentTypeProvider = "paylogin";
            }
            if ($scope.paymentType == 8) {
                $scope.paymentType = 7;
                $scope.paymentTypeProvider = "credit_paydirect";
            }

            let dateObjectOrder = prepareDataToOrder(token);

            $http({
                method: 'POST',
                url: '/GiftCard/Buy',
                data: dateObjectOrder,
                dataType: 'json',
                headers: {
                    "Content-Type": "application/json"
                }
            }).success(function (data) {

                if ((data.Error != undefined && data.Error != '') || data == "Error" || data == "False" || data == "Error Payment") {
                    $('.payment-form.cbform .payment-status').html('<div class="error-msg"></div>');
                    if (data.Error != undefined)
                        $('.payment-form.cbform .payment-status .error-msg').after('<div class="error-msg show">' + data.Error + '</div>');
                    else
                        $('.payment-form.cbform .payment-status .error-msg').after('<div class="error-msg show">There was a problem while processing the credit card! Please check all fields and credit card funds!</div>');

                    $('.steps-body .step-actions button.pay').removeClass('disabled');
                    $scope.loading = false;
                    $('body .giftcard-wrapper .payment-form .form-actions').removeClass('disabled');
                    $('.payment-form.cbform, .loader-container.cbform-loader').removeClass('loading');
                } else {
                    if ($scope.paymentType == 12) {
                        post_to_url(data, 'post');

                    }else if($scope.paymentType == 13){
                        post_to_url(data, 'post', 'https://paynow.netcash.co.za/site/paynow.aspx');
                    }else if($scope.paymentType == 14){
                        post_to_url(data, 'post', data.PaymentUrl);
                    }else if ($scope.paymentType == "1" || $scope.paymentType == "5" || $scope.paymentType == "7" || $scope.paymentType == "8") {
                        window.location.href = data;
                    }
                    
                    else {
                        $scope.finalVouchers = data.GiftCards;
                        $scope.success = true;

                        $('.steps-body .step-actions button.pay').removeClass('disabled');
                        $scope.loading = false;
                        $('body .giftcard-wrapper .payment-form .form-actions').removeClass('disabled');
                        $('.payment-form.cbform, .loader-container.cbform-loader').removeClass('loading');
                    }
                }
            }).error(function () {
                $('.steps-body .step-actions button.pay').removeClass('disabled');
                $scope.loading = false;
                $('body .giftcard-wrapper .payment-form .form-actions').removeClass('disabled');
            });
        }
    }

    function post_to_url(params, method, url) {
        let path = $scope.info.MyPosTestingMode ? 'https://www.mypos.com/vmp/checkout-test' : 'https://www.mypos.com/vmp/checkout';
        if(url){
            path = url;
        }
		method = method || "post";
	
		var form = document.createElement("form");
		form.setAttribute("method", method);
		form.setAttribute("action", path);
	
		for(var key in params) {
			if(params.hasOwnProperty(key)) {
				var hiddenField = document.createElement("input");
				hiddenField.setAttribute("type", "hidden");
				hiddenField.setAttribute("name", key);
				hiddenField.setAttribute("value", params[key]);
	
				form.appendChild(hiddenField);
			 }
		}
	
		document.body.appendChild(form);
		form.submit();
	}

    $scope.$watch('paymentType', function (v) {
        $scope.paymentType = v;

        if (v == 4) {
            if (!$scope.paySafeInit) {
                if ($scope.info.PaySafeCard == true && $scope.info.PaySafeApiKeyFrontEnd != '') {
                    $scope.paySafeInit = true;
                    // Base64 encoded version the Single-use Token API key.
                    // Create the key below by concatenating the API username and password
                    // separated by a colon and Base64-encoding the result
                    var apiKey = $scope.info.PaySafeApiKeyFrontEnd;
                    var Enviroment = "TEST";
                    if ($scope.Enviroment == true)
                        Enviroment = "LIVE";
                    var options = {

                        // select the Paysafe test / sandbox environment
                        environment: Enviroment,

                        // set the CSS selectors to identify the payment field divs above
                        // set the placeholder text to display in these fields
                        fields: {
                            cardNumber: {
                                selector: "#cardNumber",
                                placeholder: "Card number"
                            },
                            expiryDate: {
                                selector: "#expiryDate",
                                placeholder: "Expiry date"
                            },
                            cvv: {
                                selector: "#cvv",
                                placeholder: "CVV"
                            }
                        }
                    };

                    paysafe.fields.setup(apiKey, options, function (instance, error) {
                        document.getElementById("payNow").addEventListener("click", function (event) {
                            $('body .giftcard-wrapper .payment-form .form-actions').addClass('disabled');
                            instance.tokenize(function (instance, error, result) {
                                if (error) {
                                    $('body .giftcard-wrapper .payment-form .form-actions').removeClass('disabled');
                                    $('.payment-status .error-msg').addClass('show').append('<p>' + error.message + '</p>');
                                } else {
                                    $scope.placeOrder(result.token);
                                }
                            });
                        }, false);
                    });
                }
            }
        }
        else {
            $scope.ShowPaySafe = false;
        }

        if (v == 66) {
            let price =  $scope.totalPrice;
            let finalBankPrice;
            finalBankPrice = price.toFixed(2).split('.').join("");
            finalBankPrice = parseInt(finalBankPrice);

            var hostedPayments = SimplifyCommerce.hostedPayments(
                function(response) {
                    var cardToken = response.cardToken;
                    // TODO: Pass token to the server & use Simplify's API to make a payment
                    $scope.placeOrder(cardToken);
                },
                {
                    scKey: infoData.CommBankPublicApiKey,
                    amount: finalBankPrice,
                    operation: 'create.token',
                    name: infoData.SubscriptionName,
                    description: ''

                }
            ).closeOnCompletion();
            /**
             * Handle the error response from the server call that
             * failed to make a payment from the card token.
             */
            function apiPaymentErrorHandler() {
                // re-enable the payment button, so the user can try again.
                hostedPayments.enablePayBtn();
                // TODO: Handle error
            }

            $("#process-payment-hp").on("click", function () {
                $(".giftcard-wrapper .payment-form .form-head .rb-commbankhp button").trigger('click');
            })
        }

        if (v == 6) {
            $("#process-payment-btn").on("click", function () {
                $('body .giftcard-wrapper .payment-form .form-actions').addClass('disabled');
                $('.payment-form.cbform, .loader-container.cbform-loader').addClass('loading');
                // Generate a card token & handle the response
                SimplifyCommerce.generateToken({
                    key: infoData.CommBankPublicApiKey,
                    card: {
                        number: $("#cc-number").val(),
                        cvc: $("#cc-cvc").val(),
                        expMonth: $("#cc-exp-month").val(),
                        expYear: $("#cc-exp-year").val()
                    }
                }, simplifyResponseHandler);
                // Prevent the form from submitting
                return false;
            });

            function simplifyResponseHandler(data) {
                var $paymentForm = $("#payment-form");
                // Remove all previous errors
                $(".error").remove();
                // Check for errors
                if (data.error) {
                    // Show any validation errors
                    if (data.error.code == "validation") {
                        var fieldErrors = data.error.fieldErrors,
                            fieldErrorsLength = fieldErrors.length,
                            errorList = "";
                        for (var i = 0; i < fieldErrorsLength; i++) {
                            errorList += "<div class='error'>Field: '" + fieldErrors[i].field +
                                         "' is invalid - " + fieldErrors[i].message + "</div>";
                        }

                        // console.log(errorList);
                        // Display the errors
                        $('.payment-form.cbform .payment-status').html('<div class="error-msg"></div>');
                        $('.payment-form.cbform .payment-status .error-msg').after('<div class="error-msg show">' + errorList + '</div>');

                        $('.steps-body .step-actions button.pay').removeClass('disabled');
                        $('.payment-form.cbform, .loader-container.cbform-loader').removeClass('loading');
                    }
                    // Re-enable the submit button
                    $scope.loading = false;
                    $('body .giftcard-wrapper .payment-form .form-actions').removeClass('disabled');
                    $("#process-payment-btn").removeAttr("disabled");
                } else {
                    // The token contains id, last4, and card type
                    var token = data["id"];
                    // Insert the token into the form so it gets submitted to the server
                    $('.payment-form.cbform .payment-status').append("<input type='hidden' name='simplifyToken' value='" + token + "' />");
                    // Submit the form to the server

                    $scope.placeOrder(token);
                    // $paymentForm.get(0).submit();
                }
            }
        }

        if (v == 9) {
            $('#stripe-button').addClass('show');

            // Create a Stripe client.
            $scope.stripe = Stripe($scope.info.StripePublishKey);
            // Create an instance of Elements.
            var elements = $scope.stripe.elements();
            // Custom styling can be passed to options when creating an Element.
            // (Note that this demo uses a wider set of styles than the guide below.)
            var style = {
                base: {
                    color: '#32325d',
                    lineHeight: '18px',
                    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                    fontSmoothing: 'antialiased',
                    fontSize: '16px',
                    '::placeholder': {
                        color: '#aab7c4'
                    }
                },
                invalid: {
                    color: '#fa755a',
                    iconColor: '#fa755a'
                }
            };


            // Create an instance of the card Element.
            // if ($scope.currencyCode == 'EUR') {
            //     $scope.card = elements.create('card', { style: style, hidePostalCode: true });
            // } else {
            //     $scope.card = elements.create('card', { style: style });
            // }

            $scope.card = elements.create('card', {style: style, hidePostalCode: $scope.info.HidePostalCode });

            // Add an instance of the card Element into the `card-element` <div>.
            $scope.card.mount('#card-element');

            // Handle real-time validation errors from the card Element.
            $scope.card.on('change', function(event) {
                var displayError = document.getElementById('card-errors');
                if (event.error) {
                    displayError.textContent = event.error.message;
                } else {
                    displayError.textContent = '';
                }
            });

            $('#stripe-button').on('click', function (e) {
                $scope.orderLoading = true;
                e.preventDefault();

                generatePaymentIntent();
            })
        } else {
            $('#stripe-button').removeClass('show');
        }

        if(v == 10){
            $('#elavon-button').addClass('show');
        }else{
            $('#elavon-button').removeClass('show');
        }

    });

    $('#elavon-button').on('click', function (e) {
        e.preventDefault();
        // $scope.orderLoading = true;
        // $scope.placeOrder();
        generateElavonToken();

    })

    function generateElavonToken(){
        if ( $scope.loading != true ) {
            $scope.loading = true;
            $('body .giftcard-wrapper .payment-form .form-actions').addClass('disabled');

            let dateObjectOrder = prepareDataToOrder(); 
            $http({
                method: 'POST',
                url: '/giftcard/GenerateElavonToken',
                data: dateObjectOrder
            }).success(function (data) {

                openLightbox(data);
                
            }).error(function (error) {
                $('.payment-form.cbform .payment-status').html('<div class="error-msg"></div>');
                $('.payment-form.cbform .payment-status .error-msg').after('<div class="error-msg show">' + error.ExceptionMessage + '</div>');
                $scope.loading = false;
                $('body .giftcard-wrapper .payment-form .form-actions').removeClass('disabled');
                
            });
        }
    }

    function openLightbox(token) {
        var paymentFields = {
            ssl_txn_auth_token: token
        };
        var callback = {
            onError: function (error) {
                Swal.fire({
                    type: 'warning',
                    title: 'error',
                    onAfterClose: (function () {
                        $timeout(function() {
                            $scope.loading = false; 
                            $('body .giftcard-wrapper .payment-form .form-actions').removeClass('disabled');
                        });
                    })
                });

                showResult("error", error,token);
            },
            onCancelled: function () {
                // showResult("cancelled", "",token);
                Swal.fire({
                    type: 'warning',
                    title: 'Cancelled',
                    onAfterClose: (function () {
                        $timeout(function() {
                            $scope.loading = false; 
                            $('body .giftcard-wrapper .payment-form .form-actions').removeClass('disabled');
                        });
                    })
                });
            },
            onDeclined: function (response) {
                showResult("declined", JSON.stringify(response, null, '\t'), token);
                Swal.fire({
                    type: 'warning',
                    title: 'Declined',
                    onAfterClose: (function () {
                        $timeout(function() {
                            $scope.loading = false; 
                            $('body .giftcard-wrapper .payment-form .form-actions').removeClass('disabled');
                        });
                    })
                });
            },
            onApproval: function (response) {
                $scope.ElavonTransactionID = response.ssl_txn_id;
                $scope.ElavonOrderID = response.ssl_invoice_number;
                $scope.loading = false;
				$scope.placeOrder();

                // showResult("approval", JSON.stringify(response, null, '\t'),token);
            }
        };
        PayWithConverge.open(paymentFields, callback);
        return false;
    }

    function showResult(status, msg, token) {
        console.log(status, msg)

        let url = '/GiftCard/SaveElavonError/';
        let dataObject = {
            Token: token,
            Status: status,
            ExceptionText: msg,
            NameSpace: namespace
        }

        $http({
            method: 'POST',
            url: url,
            data: dataObject
        });
    }

    // Generate PaymentInted for Stripe
	function generatePaymentIntent() {
        if ( $scope.loading != true ) {
            $scope.loading = true;
            $('.payment-form.cbform .payment-status').html('<div class="error-msg"></div>');
            $('body .giftcard-wrapper .payment-form .form-actions').addClass('disabled');

            let dateObjectOrder = prepareDataToOrder(); 
            $http({
                method: 'POST',
                url: '/giftcard/GeneratePaymentIntent/',
                data: dateObjectOrder
            }).success(function (data) {

                stripeConfirmCard(data);
                $scope.PaymentIntentID = data.ID;
                
            }).error(function (error) {
                $('.payment-form.cbform .payment-status').html('<div class="error-msg"></div>');
                $('.payment-form.cbform .payment-status .error-msg').after('<div class="error-msg show">' + error.ExceptionMessage + '</div>');
                $scope.loading = false;
                $('body .giftcard-wrapper .payment-form .form-actions').removeClass('disabled');
                
            });
        }
    }
    
    function stripeConfirmCard(data){

		let name = $scope.fromFirstName + ' ' + $scope.fromLastName;

		$scope.stripe.confirmCardPayment(data.ClientSecret, {
			payment_method: {
				card: $scope.card,
				  billing_details: {
					name: name
				  }
			}
		}).then(function(result) {
			if (result.error) {
                // Show error to your customer (e.g., insufficient funds)
                $('.payment-form.cbform .payment-status').html('<div class="error-msg"></div>');
                $('.payment-form.cbform .payment-status .error-msg').after('<div class="error-msg show">' + result.error.message + '</div>');
                
                $timeout(function() {
                    $scope.loading = false;
                    $('body .giftcard-wrapper .payment-form .form-actions').removeClass('disabled'); 
                }, 100);
			} else {
				  // The payment has been processed!
				  if (result.paymentIntent.status === 'succeeded') {
                    $scope.loading = false;
                    $scope.placeOrder();
					// Show a success message to your customer
					// There's a risk of the customer closing the window before callback
					// execution. Set up a webhook or plugin to listen for the
					// payment_intent.succeeded event that handles any business critical
					// post-payment actions.
				  }
			}
		});
	}

    $('.giftcard-wrapper .box-head i').on('click', function () {
        $('.giftcard-wrapper').toggleClass('show-cart');
    });

    $('.menu-trigger').on('click', function (e) {
        e.preventDefault();
        $('.header').toggleClass('show-menu');
    });

    // Get Language from backend settings
	function getLanguage(culture){
        let lang = culture.split('-');
		lang = lang[1].toLowerCase();
		return lang;
	}

    $(window).on('load', function(){
        if (giftCard) {
            $timeout(() => {
                $scope.getCards(giftCard);
                $scope.giftCard = giftCard;
            })
        }
        
        let phoneLang = getLanguage($scope.gym[0].Culture);
        var inputInitPhone = document.querySelector("#Telephone");
        if(inputInitPhone){
            $scope.inputPhone = window.intlTelInput(inputInitPhone, {
                autoHideDialCode: false,
                preferredCountries: [phoneLang],
                separateDialCode: true
            });

            inputInitPhone.addEventListener("countrychange", function() {
                let countryinfo = $scope.inputPhone.getSelectedCountryData()
                if(countryinfo.dialCode == '44'){
                    $scope.phoneFormat = /^[0-9]{5,11}$/;
                }else{
                    $scope.phoneFormat = /^[0-9]{5,15}$/;
                    $scope.waiverForm.Telephone.$validate()
                }
            });
        }

        $('.giftcard-wrapper').addClass('loaded');

        getBackEndCart();
    })

}]);

app.controller('GiftCardStatusController', ['$scope', '$http', '$routeParams', '$translate', '$window', function ($scope, $http, $routeParams, $translate, $window) {
    $scope.order = order;
    $scope.info = infoData;
    $scope.logo = logo;

    $scope.hrefStart = window.location.origin + '/giftcard/index?GymID=' + infoData.GymID + '&NameSpace=' + infoData.NameSpace;

    $scope.Language = infoData.Country;

    if ($scope.Language.indexOf('bg') > -1) {
        $translate.use('bg')
    }else if ($scope.Language.indexOf('esm') > -1 || $scope.Language.indexOf('esn') > -1) {
        $translate.use('es')
    }else if($scope.Language.indexOf('cat') > -1){
        $translate.use('esc')
    }else if($scope.Language.indexOf('mex') > -1){
        $translate.use('esm')
    }else if ($scope.Language.indexOf('pl') > -1) {
        $translate.use('pl')
    }else if ($scope.Language.indexOf('pt') > -1) {
        $translate.use('pt')
    }else if ($scope.Language.indexOf('it') > -1) {
        $translate.use('it')
    }else if ($scope.Language.indexOf('ro') > -1) {
        $translate.use('ro')
    }else if ($scope.Language.indexOf('lt') > -1) {
        $translate.use('lt')
    }else if ($scope.Language.indexOf('id') > -1) {
        $translate.use('id')
    }else if ($scope.Language.indexOf('de') > -1) {
        $translate.use('de')
    }else {
        $translate.use('en')
    }

    if ($scope.Language.indexOf('ena') > -1 || $scope.Language.indexOf('enu') > -1) {
        $scope.beyondTheOcean = true;
    }
}]);